(function () {
  'use strict';

  /* @ngdoc object
   * @name flightPunctuality
   * @description
   *
   */
  angular
    .module('flightPunctuality', [
      'ui.router'
    ]);
}());
